import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ALL_FILTER,
  CONFERENCE_ARTICLE,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_LIST,
  CONFERENCE_ARTICLE_PROOF,
  CONFERENCE_ARTICLE_STEP,
  CONFERENCE_CATEGORY_ALL,
  CONFERENCE_CREATE,
  CONFERENCE_MAGAZINE_ARTICLE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const conference = createAsyncThunk(
  CONFERENCE,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.conference(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceCreate = createAsyncThunk(
  CONFERENCE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.conferenceCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceAll = createAsyncThunk(
  CONFERENCE_ALL,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_ALL}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.conferenceAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticle = createAsyncThunk(
  CONFERENCE_ARTICLE,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.conferenceArticle(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticleList = createAsyncThunk(
  CONFERENCE_ARTICLE_LIST,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE_LIST}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceArticleList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticleStep = createAsyncThunk(
  CONFERENCE_ARTICLE_STEP,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE_STEP}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.conferenceArticleStep(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceAllFilter = createAsyncThunk(
  CONFERENCE_ALL_FILTER,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_ALL_FILTER}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceAllFilter(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticleProof = createAsyncThunk(
  CONFERENCE_ARTICLE_PROOF,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE_PROOF}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.conferenceArticleProof(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticleAll = createAsyncThunk(
  CONFERENCE_ARTICLE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceArticleAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceMagazineArticle = createAsyncThunk(
  CONFERENCE_MAGAZINE_ARTICLE,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_MAGAZINE_ARTICLE}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceMagazineArticle(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceCategoryAll = createAsyncThunk(
  CONFERENCE_CATEGORY_ALL,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_CATEGORY_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.conferenceCategoryAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceClear = createAction(`${CONFERENCE}/clear`)
export const conferenceArticleClear = createAction(`${CONFERENCE_ARTICLE}/clear`)

export const conferenceAllClear = createAction(`${CONFERENCE_ALL}/clear`)

export const conferenceAllFilterClear = createAction(`${CONFERENCE_ALL_FILTER}/clear`)

export const conferenceArticleListClear = createAction(`${CONFERENCE_ARTICLE_LIST}/clear`)

export const conferenceArticleAllClear = createAction(`${CONFERENCE_ARTICLE_ALL}/clear`)

export const conferenceMagazineArticleClear = createAction(`${CONFERENCE_MAGAZINE_ARTICLE}/clear`)

export const conferenceCategoryAllClear = createAction(`${CONFERENCE_CATEGORY_ALL}/clear`)
